export default "__VITE_ASSET__Cx_sqF18__"